import { useTranslation } from "react-i18next";
import { WheelhouseSectionWrapper } from "./styles";
import { IoIosInformationCircle } from "react-icons/io";
import { Switch, Tooltip } from "@mui/material";
import WellHouseIcon from "@assets/svg/well_house.svg?react";
import DisableWheelHouse from "./pop_ups/disableWheelHouse";
import ApplyWheelHouse from "./pop_ups/applyWheelHouse";
import { useEffect, useState, useCallback, memo } from "react";
import SettingsProperties from "./pop_ups/settingsProperties";
import {
  useGetMarketplaceCheckTire,
  useGetWheelhouseProperties,
} from "@services";
import AreProAccount from "./pop_ups/areProAccount";

function WheelhouseSection() {
  /* ------------------------------- Local State ------------------------------ */
  const [isAreProAccountEnabeled, setIsAreProAccountEnabeled] = useState(false);
  const [isSwitchActive, setIsSwitchActive] = useState(false);
  const [isPopUpEnabeled, setIsPopUpEnabeled] = useState({
    disable: false,
    apply: false,
  });
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const [isSettingsPropertiesOpen, setIsSettingsPropertiesOpen] =
    useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  /* ---------------------------------- Hooks --------------------------------- */
  const { t } = useTranslation();
  /* ---------------------------------- API'S --------------------------------- */
  const { data: GetMarketplaceCheckTire, refetch: refetch2, isPending } =
    useGetMarketplaceCheckTire({}, {
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh
      gcTime: 10 * 60 * 1000, // 10 minutes - cache persists
      refetchOnMount: false, // Don't refetch on component mount
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnReconnect: false, // Don't refetch on reconnect
    });
  const { data: dataWheelhouseProperties, refetch } =
    useGetWheelhouseProperties({
      searchKey,
    }, {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    });
  /* -------------------------------- Functions ------------------------------- */
  const closePopUp = useCallback(() => {
    setIsSwitchActive(false);
    setIsPopUpEnabeled({
      disable: false,
      apply: false,
    });
  }, []);
  /* --------------------------------- Effect --------------------------------- */
  useEffect(() => {
    if (dataWheelhouseProperties?.result) {
      const hasActive = dataWheelhouseProperties.result.some(
        (item) => item.isActive
      );
      setIsChecked(hasActive);
    }
  }, [dataWheelhouseProperties]);

  useEffect(() => {
    if (isSwitchActive && isPopUpEnabeled.apply) {
      setIsPopUpEnabeled({
        apply: true,
        disable: false,
      });
    }
    if (isSwitchActive && isPopUpEnabeled.disable) {
      setIsPopUpEnabeled({
        apply: false,
        disable: true,
      });
    }
  }, []);

  const handleCheckTire = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("should call the request", isPending)
    // if (!isPending) {
    if (e.target.checked) {
      const getMarketplaceCheckTireResponse =  await refetch2()
      getMarketplaceCheckTireResponse?.data?.result === "Free"
                  ? setIsAreProAccountEnabeled(true)
                  : setIsSettingsPropertiesOpen(true)
    } else {
      setIsPopUpEnabeled({
        apply: false,
        disable: true,
      });
    }
    // }
  }, [isPending, refetch2])

  const handleCloseAreProAccount = useCallback(() => {
    setIsAreProAccountEnabeled(false);
  }, []);

  const handleRefetchAll = useCallback(() => {
    refetch();
    refetch2();
  }, [refetch, refetch2]);

  const handleToggleSettingsProperties = useCallback(() => {
    if (GetMarketplaceCheckTire?.result !== "Free") {
      setIsSettingsPropertiesOpen(!isSettingsPropertiesOpen);
    } else {
      setIsAreProAccountEnabeled(true)
    }
  }, [GetMarketplaceCheckTire?.result, isSettingsPropertiesOpen]);

  return (
    <WheelhouseSectionWrapper>
      {isAreProAccountEnabeled && (
        <AreProAccount closePopUp={handleCloseAreProAccount} />
      )}
      {isPopUpEnabeled.disable && (
        <DisableWheelHouse 
          closePopUp={closePopUp} 
          dataWheelhouseProperties={dataWheelhouseProperties}
          refetch={handleRefetchAll}
        />
      )}
      {isPopUpEnabeled.apply && (
        <ApplyWheelHouse closePopUp={closePopUp} isLoaderOpen={isLoaderOpen} />
      )}
      {isSettingsPropertiesOpen && (
        <SettingsProperties
          setSearchKey={setSearchKey}
          setIsSettingsPropertiesOpen={setIsSettingsPropertiesOpen}
          setIsPopUpEnabeled={setIsPopUpEnabeled}
          dataWheelhouseProperties={dataWheelhouseProperties}
          refetch={handleRefetchAll}
          setIsLoaderOpen={setIsLoaderOpen}
          isLoaderOpen={isLoaderOpen}
        />
      )}
      <div className="containerWheelhouseSection">
        <div className="first">
          <div>
            <Switch
              checked={isChecked}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCheckTire(e)}
            />
          </div>
          <div>
            <span>
              <WellHouseIcon />
            </span>
            <span>{t("CALENDAR.automatic_pricing")}</span>
          </div>
          <Tooltip
            title={t(
              "CALENDAR.When you enable automatic pricing, the suggested prices from Wellhouse will be used and updated across all your connected channels on the Masoul platform"
            )}
          >
            <div>
              <IoIosInformationCircle />
            </div>
          </Tooltip>
        </div>
        <div className="second">
          <button
            type="button"
            onClick={handleToggleSettingsProperties}
          >
            {t("AutomationCentre.settings")}
          </button>
        </div>
      </div>
    </WheelhouseSectionWrapper>
  );
}

WheelhouseSection.displayName = 'WheelhouseSection';

export default memo(WheelhouseSection);
